import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

import Select from "react-select";
import { Link, useLocation } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const WithdrawalRequest = props => {
  //meta title
  document.title = "Withdrawal Requests";
  const { getRequest, postRequest } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      status: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = TransactionData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setTransactionTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      wt_id: elementData.wt_id,
      status: elementData.status,
      information: elementData.information,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      wt_id: '',
      status: '',
      information: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          wt_id: values.wt_id,
          status: values.status,
          information: values.information
        });
        const res = await postRequest('update-withdrawal-transaction-status', jsonpar);
        if (res && res.code === 200) {
            handleLoadGetTransactionData();
            setTimeout(() => {
              validation1.handleSubmit();
            }, 500);

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [TransactionData, setTransactionData] = React.useState([]);
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.wt_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{formatDate(element.created_at)}</td>
        <td>{formatCurrency(element.withdraw_amount)}</td>
        {/* <td>{formatCurrency(element.fees)} &nbsp;({element.fees_per}%) </td>
        <td>{formatCurrency(element.total_amount)}</td> */}
        <td style={{ minWidth: "300px" }}>
                    {/* Legend above the bar */}
                    <div style={{ marginBottom: '4px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {element.used && element.used.map((source, sIdx) => {
                        const colors = ["#036B41", "#4A90E2", "#8E7CC3", "#D98C2B"];
                        // Check if this is a bonus entry
                        const isBonus = source.token_symbol === 'BONUS' || source.propert_name === 'Bonus';
                        const displayLabel = isBonus ? 'Bonus' : (source.token_symbol?.split('-')[1] || 'PJ');
                        
                        return (
                          <span key={sIdx} style={{ fontSize: '10px', fontWeight: '600', whiteSpace: 'nowrap' }}>
                            <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: colors[sIdx % colors.length], marginRight: '3px' }}></span>
                            {displayLabel} {formatCurrency(source.amount)}
                          </span>
                        );
                      })}
                    </div>
                    <div className="progress" style={{ height: "18px", borderRadius: "4px", backgroundColor: "#f0f0f0" }}>
                      {element.used && element.used.map((source, sIdx) => {
                        const widthPercent = (source.amount / element.withdraw_amount) * 100;
                        const colors = ["#036B41", "#4A90E2", "#8E7CC3", "#D98C2B"];
                        
                        return (
                          <div
                            key={sIdx}
                            className="progress-bar"
                            role="progressbar"
                            style={{ 
                              width: `${widthPercent}%`, 
                              backgroundColor: colors[sIdx % colors.length]
                            }}
                            title={`${source.propert_name}: ${formatCurrency(source.amount)}`}
                          >
                          </div>
                        );
                      })}
                    </div>
        </td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{element.status}</span></td>
        <td className="text-center">
          <div className="centerLink">
            {element.status === 'Pending'?
            <Button className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Button>
            : ''}
            <span className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></span>
            <Link title="User Wallet" to={"/withdraw-request-user_wallet/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-wallet"></i></Link>
          </div>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    
    const res = await getRequest('get-withdrawal-breakdown');
    if (res && res.code === 200) {
      console.log(res.data.withdrawBreakdown)
      handleT1Body(res.data.withdrawBreakdown);
      setTransactionData(res.data.withdrawBreakdown);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  
  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [{label: 'All', value: 'All'}];
      res.data.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersData(tempArr);
    }
  }
  React.useEffect(() => {
    handleLoadGetTransactionData();
    handleLoadGetUsers();
  }, []);


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Withdrawal Requests")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={4} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Users : </label>
                          <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                      <table className="table mb-0" style={{ minWidth: "1000px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Date</th>
                            <th>Amount</th>
                            {/* <th>Fees</th>
                            <th>Total Amount</th> */}
                            <th className="text-center">Source BreakDown (Per Project)</th>
                            <th>Status</th>
                            <th className="text-center">Action</th>
                            
                          </tr>
                        </thead>
                        <tbody>
                          {TransactionTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                {/* <p className="AvailableBalance">Available Balance : <b>€5600</b></p> */}
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                  {validation2.touched.status && validation2.errors.status ? (
                    <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col xs={12}>
                <div className="mb-3">
                  <label className="form-label">Transaction Information	:</label>
                  <textarea
                    className="form-control"
                    name="information"
                    placeholder={'Transaction Information'}
                    onChange={validation2.handleChange}
                    value={validation2.values.information || ""}
                  >
                  </textarea>
                </div>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary"
                id="submit2"
                onClick={(e) => {
                  e.preventDefault();
                  validation2.handleSubmit();
                  return false;
                }}
              > Update </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">Close</button>
            </div>
          </Modal>


          <Modal className="transation" size="lg" centered backdrop="static" isOpen={StandardModal1}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Withdrawal Details</h5>
              <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mb-3">
              <div className="row">
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>ID :</b> <span className="">{Transaction.wt_id}</span></p>
                  <p className="mb-1 border-box-1"><b>First Name :</b> <span className="">{Transaction.first_name}</span></p>
                  <p className="mb-1 border-box-1"><b>Last Name :</b> <span className="">{Transaction.last_name}</span></p>
                  {/* <p className="mb-1 border-box-1"><b>Email ID :</b> <span className="">{Transaction.email}</span></p> */}
                  <p className="mb-1 border-box-1"><b>Date :</b> <span className="">{formatDate(Transaction.created_at)}</span></p>
                  <p className="mb-1 border-box-1"><b>Amount :</b> <span className="">{formatCurrency(Transaction.withdraw_amount)}	</span></p>
                  {/* <p className="mb-1 border-box-1"><b>Fees :</b> <span className="">{formatCurrency(Transaction.fees)} &nbsp;({Transaction.fees_per}%)</span></p>
                  <p className="mb-1 border-box-1"><b>Total Amount :</b> <span className="">{formatCurrency(Transaction.total_amount)}	</span></p> */}
                  <p className="mb-1 border-box-1"><b>Status :</b> <span className=""><span className={"font-size-14 badge bg-secondary rounded-pill " + (Transaction.status === 'Pending' ? 'badge-soft-warning' : Transaction.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{Transaction.status}</span></span></p>
                </div>
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>Payment Detail :</b></p>
                  <p className="mb-1">Account Holder Name : {Transaction.account_holder_name} <br /> IBAN No. : {Transaction.bank_account_number} <br /> Swift Code : {Transaction.swift_code}</p>
                  {Transaction.information !== '' && Transaction.information !== null?
                  <>
                    <p className="mb-2 border-box-1 mt-4"><b>Transaction Information :</b></p>
                    <p className="mb-1"><span>{Transaction.information}</span></p>
                  </>
                  :''}
                </div>
              </div>
            </div>
          </Modal>
        </Container>
      </div>

    </React.Fragment >
  );
};

export default withTranslation()(WithdrawalRequest);
